import { clsx } from "clsx";
import React from "react";
import { GlowBg } from "../../ui/glow-bg";

export const LandingFooter = ({
  className,
  children,
  title,
  description,
  descriptionFooter,
  footnote,
  logoComponent,
  withBackground = false,
  withBackgroundGlow = false,
  withBackgroundGradient = false,
  variant = "primary",
  backgroundGlowVariant = "primary",
}: {
  className?: string;
  children?: React.ReactNode;
  title?: string;
  description?: string;
  descriptionFooter?: React.ReactNode;
  footnote?: string | React.ReactNode;
  logoComponent?: React.ReactNode;
  withBackground?: boolean;
  withBackgroundGlow?: boolean;
  withBackgroundGradient?: boolean;
  variant?: "primary" | "secondary";
  backgroundGlowVariant?: "primary" | "secondary";
}) => {
  const columnNumber = React.Children.count(children);

  return (
    <footer
      className={clsx(
        "mt-auto w-full bg-gradient-to-r",
        withBackground && variant === "primary"
          ? "bg-primary-100/20 dark:bg-primary-900/10"
          : "",
        withBackground && variant === "secondary"
          ? "bg-secondary-100/20 dark:bg-secondary-900/10"
          : "",
        withBackgroundGlow ? "relative overflow-hidden" : "",
        withBackgroundGradient
          ? "from-gray-50/5 via-gray-100/60 to-gray-50/5 backdrop-blur-sm dark:from-slate-700/5 dark:via-slate-700/60 dark:to-slate-700/5"
          : "",
        className,
      )}
    >
      {withBackgroundGlow ? (
        <div className="hidden lg:flex justify-center w-full h-full absolute -bottom-1/2 pointer-events-none">
          <GlowBg
            className={clsx("w-full h-auto z-0 dark:opacity-50 opacity-100")}
            variant={backgroundGlowVariant}
          />
        </div>
      ) : null}

      <div
        className={clsx(
          "flex flex-col gap-4 justify-between items-center w-full p-6",
        )}
      >
        <div className="w-full flex flex-col md:flex-row justify-between gap-6 p-6 max-w-full container-wide">
          <div className="w-full flex flex-col md:max-w-xs lg:max-w-sm">
            <a className="text-2xl" href="/">
              {logoComponent}
            </a>

            {title ? (
              <div className="text-lg font-semibold">{title}</div>
            ) : null}

            {description ? (
              <p className="text-sm opacity-70">{description}</p>
            ) : null}

            {descriptionFooter ? <div>{descriptionFooter}</div> : null}
          </div>

          {columnNumber > 0 ? (
            <div
              className={clsx(
                "grid md:grid-cols-2 gap-12 items-start mt-6 md:mt-0",
                columnNumber === 3 ? "md:grid-cols-3" : "",
                columnNumber === 4 ? "lg:grid-cols-4" : "",
              )}
            >
              {children}
            </div>
          ) : null}
        </div>
      </div>

      {footnote ? (
        <div>
          <div className="flex flex-col items-center">
            <div className="w-full text-center lg:flex lg:justify-center p-1 mb-2 space-x-2 text-sm text-gray-500 dark:text-gray-400">
              {footnote}
            </div>
          </div>
        </div>
      ) : null}
    </footer>
  );
};
